<script setup lang="ts">
import { DialogRoot } from 'radix-vue'
</script>

<template>
	<DialogRoot>
		<slot />
	</DialogRoot>
</template>
